import type { JSX } from 'react';
import React from 'react';

import type { CampaignClass, ECampaignObjective } from '@feathr/blackbox';
import type { IRadioOption } from '@feathr/components';
import { Radios } from '@feathr/components';
import { useObjectiveUtils } from '@feathr/extender/hooks';

import styles from './ObjectiveStep.css';

export interface IObjectiveStepProps {
  campaignType: CampaignClass;
  selectedObjective?: ECampaignObjective;
  onObjectiveChange: (objective: ECampaignObjective) => void;
}

function ObjectiveStep({
  campaignType,
  selectedObjective,
  onObjectiveChange,
}: Readonly<IObjectiveStepProps>): JSX.Element {
  const { createOptionsForCampaignType } = useObjectiveUtils();

  const options = createOptionsForCampaignType(campaignType, {
    name: styles.name,
    prefix: styles.prefix,
    prefixDisabled: styles.prefixDisabled,
    lockIcon: styles.lockIcon,
  });

  return (
    <Radios
      contentOrientation={'vertical'}
      hideRadioInput={true}
      layout={'block'}
      name={'campaign-objective'}
      onChange={(value?: string): void => {
        if (value) {
          onObjectiveChange(value as ECampaignObjective);
        }
      }}
      options={options as IRadioOption[]}
      orientation={'horizontal'}
      value={selectedObjective ?? ''}
    />
  );
}

export default ObjectiveStep;
